/* eslint-disable import/no-anonymous-default-export */
import HttpService from './http.service';

/**
 * Interfaz para la solicitud de envío de confirmación por WhatsApp
 */
export interface WhatsAppConfirmationRequest {
  To: string;                 // Número de teléfono de la empresa (con formato internacional)
  CompanyName: string;        // Nombre de la empresa
  ServiceName: string;        // Nombre del servicio
  UserRequestName: string;    // Nombre del usuario que solicitó el servicio
  DateTime?: string;          // Fecha y hora del servicio (opcional)
  CityName: string;           // Nombre de la ciudad
  UserRequestEmail: string;   // Email del usuario
  userRequestPhone?: string;  // Número de teléfono del usuario que solicita el servicio
}

/**
 * Servicio para manejar las comunicaciones por WhatsApp
 */
class WhatsAppService {
  /**
   * Envía un mensaje de confirmación por WhatsApp a la empresa
   * @param data Datos para el mensaje de confirmación
   * @returns Promesa con la respuesta del servidor
   */
  async sendConfirmation(data: WhatsAppConfirmationRequest): Promise<any> {
    try {
      // Convertir la fecha al formato ISO 8601 si es necesario
      let formattedDateTime = data.DateTime;

      // Si no hay fecha, usar la fecha actual
      if (!formattedDateTime) {
        formattedDateTime = new Date().toISOString();
      }
      // Si la fecha está en formato DD/MM/YYYY HH:MM, convertirla a ISO 8601
      else if (/^\d{2}\/\d{2}\/\d{4} \d{2}:\d{2}$/.test(formattedDateTime)) {
        const [datePart, timePart] = formattedDateTime.split(' ');
        const [day, month, year] = datePart.split('/');
        const [hours, minutes] = timePart.split(':');

        // Crear un objeto Date y formatear como ISO string
        const date = new Date(Number(year), Number(month) - 1, Number(day), Number(hours), Number(minutes));
        formattedDateTime = date.toISOString();
      }

      // Crear el objeto de solicitud directamente sin envolverlo
      const requestBody = {
        To: data.To,
        CompanyName: data.CompanyName,
        ServiceName: data.ServiceName,
        UserRequestName: data.UserRequestName,
        DateTime: formattedDateTime,
        CityName: data.CityName,
        UserRequestEmail: data.UserRequestEmail,
        userRequestPhone: data.userRequestPhone // Número de teléfono del usuario
      };

      const response = await HttpService.post(
        '/api/whatsapp/send-confirmation',
        requestBody
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  formatPhoneNumber(phone: string): string {
    const cleanPhone = phone.replace(/\D/g, '');
    if (!cleanPhone.startsWith('57')) {
      return `+57${cleanPhone}`;
    }
    return `+${cleanPhone}`;
  }
}

//export default new WhatsAppService();
const whatsAppService = new WhatsAppService();
export default whatsAppService;
